import Big from "big.js"
import { GetCartTransactionResponse } from "../hooks/api/use-cart-transaction"

export const calculateBIRReceiptDetails = (trx: GetCartTransactionResponse) => {
  const customerLocation =
    trx?.customerLocation ?? trx.customer?.customerLocations?.[0]

  const totalTax =
    trx?.taxes
      ?.reduce((acc, tax) => acc.add(tax.amount), Big(0))
      .round(2)
      .toNumber() ?? 0
  const totalTaxExemption =
    trx?.taxExemptions?.reduce((acc, tax) => acc + tax.amount, 0) ?? 0
  const totalTaxApplied = totalTax - totalTaxExemption

  let vatSalesAmount = 0
  let vatRate = trx.taxes?.find((t) => t.type === "INCLUDED")?.rate || 0

  trx.orderedProducts
    .filter((p) => {
      if (trx.taxExemptions?.length && p.enableBIR) {
        return false
      }
      return p.taxable
    })
    .forEach((p) => {
      if (
        trx.location?.isVatRegistered &&
        trx.location?.isVatRegistered.toLowerCase() === "yes"
      ) {
        vatSalesAmount += p.totalPrice
      }
    })

  vatSalesAmount = vatSalesAmount
    ? Big(vatSalesAmount).minus(trx.discount).round(2).toNumber()
    : 0

  // recalculate tax for BIR as BE calculate the tax before discount
  const totalVatTax = ((vatSalesAmount / (1 + vatRate / 100)) * vatRate) / 100
  const taxes = trx.taxes
    ?.map(
      (item) =>
        // DON'T RECALCULATE, This will create discrepancy in display and printed version
        // item.rate === vatRate && item.type === "INCLUDED"
        //   ? {
        //       ...item,
        //       amount: totalVatTax,
        //     }
        //   : item
        item
    )
    .filter((t) => t.type === "INCLUDED")

  let vatExemptSales = 0
  if (trx.taxExemptions?.length) {
    trx.orderedProducts
      .filter((p) => p.enableBIR)
      .forEach((p) => {
        vatExemptSales += p.totalPrice
      })
    vatExemptSales = Big(vatExemptSales).minus(trx.discount).round(2).toNumber()
  }

  let zeroRatesSales = 0
  trx.orderedProducts
    .filter((p) => !p.taxable)
    .forEach((p) => {
      zeroRatesSales += p.totalPrice
    })

  const originalReceipt = trx.receiptHistory?.find(
    (el) => el.type === "ORIGINAL"
  )
  const originalTransNumber = originalReceipt?.seriesNumber
  const originalORNumber = originalReceipt?.ORNumber
  const totalIncludedTaxes =
    trx.taxes
      ?.filter((t) => t.type === "INCLUDED")
      ?.reduce((acc, tax) => acc + tax.amount, 0) || 0

  return {
    customerLocation,
    totalTax,
    totalTaxExemption,
    totalTaxApplied,
    vatExemptSales,
    zeroRatesSales,
    originalTransNumber,
    originalORNumber,
    totalIncludedTaxes,
    vatSalesAmount,
    totalVatTax: totalTax,
    taxes,
  }
}
